import styled from 'styled-components';

const Section = styled.section.attrs({
  className: `w-full px-6 py-2`,
})``;

export default Section;
